// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner {\n  height: 80px;\n  width: 100%; }\n", "",{"version":3,"sources":["webpack://src/pages/Event/style.scss"],"names":[],"mappings":"AAAA;EACI,YAAY;EACZ,WAAW,EAAA","sourcesContent":[".banner{\n    height: 80px;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
